import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { manageTeamStore } from 'state/league/manageTeam'
import AddTeamForm from './ModalContent/AddTeamForm'

interface AddTeamModalProps {}

const AddTeamModal: React.FC<AddTeamModalProps> = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addTeamModal, setAddTeamModal, setManageTeamModal, setSelectedTeam, setStepCounter, selectedTeam } =
    manageTeamStore(state => ({
      addTeamModal: state.addTeamModal,
      setAddTeamModal: state.setAddTeamModal,
      setManageTeamModal: state.setManageTeamModal,
      setSelectedTeam: state.setSelectedTeam,
      setStepCounter: state.setStepCounter,
      selectedTeam: state.selectedTeam,
    }))

  const handleClose = () => {
    setSelectedTeam(null)
    setStepCounter(0)
    setManageTeamModal(true)
    setAddTeamModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={addTeamModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title={selectedTeam ? 'Edit Team' : 'Add Team'}
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-between"
            btnText="Cancel,Save"
            btnType={'primary'}
            closeModal={handleClose}
            onSubmit={handleSubmit}
          />
        }
      >
        <AddTeamForm form={form} />
      </CustomModal>
    </>
  )
}

export default AddTeamModal
